// Napisy wspólne dla ekranów lekcji dziecka (patch-33): przyciski i podpisy, które powtarzają się w kilku zadaniach (Posłuchaj, Dalej, Wstecz, Sprawdź…).
// Jedno słownictwo EN/PL w całej lekcji; napisy, które należą tylko do jednego ekranu, mają swój słownik `T` na górze jego pliku.
// Polska wersja = dokładnie dotychczasowy tekst (testy widoków na atrapach bez `ctx.teacher` nadal widzą polskie napisy).
import type { Pair } from './i18n.ts';

export const L = {
  listen: { en: 'Listen', pl: 'Posłuchaj' },
  slowly: { en: 'Slowly', pl: 'Wolno' },
  next: { en: 'Next', pl: 'Dalej' },
  back: { en: 'Back', pl: 'Wstecz' },
  check: { en: 'Check', pl: 'Sprawdź' },
  hint: { en: 'Hint', pl: 'Podpowiedź' },
  showAnswer: { en: 'Show answer', pl: 'Popraw' },
  showAnswerTitle: { en: 'Show the correct answer', pl: 'Pokaż poprawną odpowiedź' },
  inPolish: { en: 'In Polish', pl: 'Po polsku' },
  inPolishLabel: { en: 'In Polish: ', pl: 'Po polsku: ' },
  polishTranslation: { en: 'Polish translation', pl: 'Tłumaczenie na polski' },
  listenToSentence: { en: 'Listen to the sentence', pl: 'Posłuchaj zdania' },
  close: { en: 'Close', pl: 'Zamknij' },
} as const satisfies Record<string, Pair>;
